import { useTranslation } from 'react-i18next';
import NextHead from '@quicktools/shared-components/components/common/NextHead';

import Home from '../../../components/HomePages/GeneralLanding/Home';

export default function Copywriter() {
  const { t } = useTranslation();
  return (
    <>
      <NextHead
        canonicalPath={'text/ai-writer/'}
        title={t('helmet.generalLanding.title')}
        description={t('helmet.generalLanding.description')}
      />
      <Home />
    </>
  );
}
